export default "__VITE_ASSET__2XY5sIZ3__"